module.exports = __webpack_public_path__ + "static/media/Steve.e8908a7f.jpg";